import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, toDisplayString, createVNode, unref, withCtx } from "vue";
import { CdrButton, IconArrowLeft, IconArrowRight } from "@rei/cedar";
const _hoisted_1 = {
  class: "pagination"
};
const _hoisted_2 = {
  "data-ui": "pagination-pages"
};
const _hoisted_3 = {
  class: "pagination__navigation"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsPagination",
  props: {
    totalElements: {},
    minimumElement: {},
    size: {}
  },
  emits: ["metricsClick", "productReviewsPagination"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function onArrowClick(dir) {
      const direction = dir > 0 ? "forward" : "back";
      emit("metricsClick", {
        linkName: `product_reviews_paginate_${direction}`
      });
      emit("productReviewsPagination", dir);
    }
    const minEntry = computed(() => props.minimumElement / 10);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createElementVNode("div", _hoisted_2, toDisplayString(minEntry.value + 1) + " - " + toDisplayString(minEntry.value + _ctx.size) + " of " + toDisplayString(_ctx.totalElements) + " Reviews ", 1), createElementVNode("div", _hoisted_3, [createVNode(unref(CdrButton), {
        class: "pagination__button--prev",
        "data-ui": "pagination-button-prev",
        "aria-label": "Previous Page Button",
        "icon-only": true,
        "with-background": true,
        disabled: minEntry.value === 0,
        onClick: _cache[0] || (_cache[0] = ($event) => onArrowClick(-1))
      }, {
        default: withCtx(() => [createVNode(unref(IconArrowLeft))]),
        _: 1
      }, 8, ["disabled"]), createVNode(unref(CdrButton), {
        class: "pagination__button--next",
        "data-ui": "pagination-button-next",
        "aria-label": "Next Page Button",
        "icon-only": true,
        "with-background": true,
        disabled: minEntry.value + _ctx.size >= _ctx.totalElements,
        onClick: _cache[1] || (_cache[1] = ($event) => onArrowClick(1))
      }, {
        default: withCtx(() => [createVNode(unref(IconArrowRight))]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsPagination2.mjs.map
